import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { ASBESTOS_AUDIT_REPORT_QUERY } from '../../../graphql.js'
import { Link } from 'react-router-dom'
import AuditReportForm from './AuditReportForm'
import { handleGraphQLErrors, makeInteger } from '../../../utils.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { getInputParams } from '../CustomUtils.js'

const ASBESTOS_AUDIT_REPORT = gql(ASBESTOS_AUDIT_REPORT_QUERY)

export default function AuditReport({ location }) {
  console.log('AuditReport rendered:')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [oldLocation, setOldLocation] = useState()

  useEffect(() => {
    async function submitSearch() {
      const inputs = getInputParams(location)
      if (results && inputs.report !== '10') {
        setResults(null)
      }
      try {
        if (inputs.report === '10') {
          const link = document.createElement('a')
          document.body.appendChild(link)
          link.href = `audit_report.report_pdf?inputs=${JSON.stringify(inputs)}`
          link.setAttribute('type', 'hidden')
          link.setAttribute('target', '_blank')
          link.click()
        } else {
          const { data, errors } = await window.apolloClient.query({ query: ASBESTOS_AUDIT_REPORT, variables: { inputs: inputs } })
          if (data.asbestosAuditReport) {
            setResults(data.asbestosAuditReport)
            setOldLocation(location)
          }
          if (errors) {
            setGraphQLErrors(errors)
          }
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    submitSearch()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let highlightedColumn
    let inputs = getInputParams(location)
    if (inputs.report === '10' && oldLocation) {
      inputs = getInputParams(oldLocation)
    }
    switch (inputs.report) {
      case '1':
      case '6':
        highlightedColumn = 1
        break
      case '7':
        highlightedColumn = 2
        break
      case '8':
      case '9':
        highlightedColumn = 11
        break
      default:
        highlightedColumn = inputs.report
    }

    let alignment = 'left'
    const resultRows = []
    let row = []
    for (let i = 0; i < results.reportData.length; i++) {
      let color = 'white'
      if ((i % 2) !== 0) {
        color = 'lightgreen'
      }
      row.push(<td key={-3} rowSpan={2} style={{verticalAlign: 'middle', backgroundColor: color}}>{i+1}</td>)
      for (let j = 1; j < results.reportData[i].length/2; j++) {
        if (j === 1) {
          row.push(<td key={-1} style={{backgroundColor: color}} align="right"><b>From</b></td>)
        }
        if (j === results.reportData[i].length/2 - 1) {
          alignment = 'right'
        }
        if (j === makeInteger(highlightedColumn)) {
          row.push(<td key={j} style={{backgroundColor: 'lightgoldenrodyellow'}} align={alignment}>{results.reportData[i][j]}</td>)
        } else {
          row.push(<td key={j} style={{backgroundColor: color}} align={alignment}>{results.reportData[i][j]}</td>)
        }
        alignment = 'left'
      }
      row.push(<td key={-2} rowSpan={2} style={{verticalAlign: 'middle', backgroundColor: color}}><Link to={`/object/${results.reportData[i][0]}?source=${location.pathname}${location.search}`}><Button className={results.reportData[i][0]} color="primary" size="sm">View</Button></Link></td>)
      resultRows.push(<tr key={i}>{row}</tr>)
      row = []
      for (let j = results.reportData[i].length/2 + 1; j < results.reportData[i].length; j++) {
        if (j === results.reportData[i].length/2 + 1) {
          row.push(<td key={-1} style={{backgroundColor: color}} align="right"><b>To</b></td>)
        }
        if (j === results.reportData[i].length - 1) {
          alignment = 'right'
        }
        if ((j - 12) === makeInteger(highlightedColumn)) {
          row.push(<td key={j} style={{backgroundColor: 'lightgoldenrodyellow'}} align={alignment}>{results.reportData[i][j]}</td>)
        } else {
          row.push(<td key={j} style={{backgroundColor: color}} align={alignment}>{results.reportData[i][j]}</td>)
        }
        alignment = 'left'
      }
      resultRows.push(<tr key={i}>{row}</tr>)
      row = []
    }
    return (
      <div className="custom-scroll">
        <AuditReportForm location={location} />
        <Table bordered style={{width: 'auto', marginLeft: 'auto', marginRight: 'auto'}}>
          <thead>
            <ColumnHeadings results={results} />
          </thead>
          <tbody>
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}
